// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"6deb190f","409":"2177b017","963":"c0bcef78"}[chunkId] + ".chunk.js";
};